import {
  GlobalActions,
  GlobalEventDispatcher,
  ModalType,
  NavigationRoute,
} from '@ps20-frontend/shop-integration-redux';
import { App, getAppEnumByAppName, getAppTitle } from '@ps20-frontend/frontend-models';
import { BeforeUnloadEventHandler } from '@ps20-frontend/shop-integration';
import { IAppState } from './store/localStore';
import { ChildAppsConfig } from './childAppsConfig';

export class LocationChangedHandler {
  isHostLocal: boolean;
  firstNavigation: boolean;

  constructor(
    private readonly windowObj: Window,
    private readonly globalEventDispatcher: GlobalEventDispatcher,
    private readonly childAppConfig: ChildAppsConfig,
  ) {
    windowObj.addEventListener('popstate', this.handlePopstate.bind(this));
    windowObj.addEventListener('hashchange', this.handleHashchange.bind(this));
    this.isHostLocal = windowObj.location && windowObj.location.hostname === 'localhost';
    if (!this.isHostLocal) {
      BeforeUnloadEventHandler.register();
    }
  }

  emitCurrentLocation(): void {
    this.handlePopstate();
  }

  // Wird bei Navigation innerhalb der App getriggered!
  private handleHashchange(): void {
    const currLoc = this.windowObj.location.href;
    this.handleDocumentTitle();
    history.pushState(null, null, currLoc);
  }

  // Wird bei AppNavigation und Browser-Back getriggered
  private handlePopstate(event: PopStateEvent | null = null): void {
    // Höre nur auf richtige Events die vom Browser kommen und ignoriere jegliche interne history Manipulation.
    if (event && !(event.currentTarget instanceof Window)) {
      return;
    }

    const state = this.globalEventDispatcher.getStateByAngebot(App.SHOP) as IAppState;
    const appName = this.childAppConfig.mapHashToAppName(this.windowObj.location.hash) || '';
    const subroute = this.childAppConfig.mapHashToSubroute(this.windowObj.location.hash);

    if (appName === App.SHOP_CHECKOUT && subroute === '/danke' && !this.isHostLocal) {
      BeforeUnloadEventHandler.remove();
    }

    if (state.canNavigate) {
      const payload: NavigationRoute = {
        appId: getAppEnumByAppName(appName),
        subroute,
      };
      const locationChangedAction = new GlobalActions().locationChanged(payload);
      this.globalEventDispatcher.dispatch(locationChangedAction);
      this.firstNavigation = true;
    } else {
      history.forward();
      if (this.firstNavigation) {
        setTimeout(() => {
          this.globalEventDispatcher.dispatch(
            new GlobalActions().requestModal(ModalType.NAVIGATION_ERROR),
          );
        }, 0);
      }
    }
    this.handleDocumentTitle();
  }

  private handleDocumentTitle(): void {
    const currentHash = this.windowObj.location.hash;
    const productKey = currentHash.split('/')[1]?.replaceAll(/-/g, '_') || '';
    let product: string;
    let position = '';

    switch (productKey) {
      case 'dashboard':
        product = 'Shop';
        break;
      case 'checkout':
        product = currentHash.includes('danke') ? 'Versand' : 'Antrag';
        break;
      default:
        product = getAppTitle((App as Record<string, App>)[productKey?.toUpperCase()]) || '';
        if (currentHash.includes('eingabe')) {
          position = 'Angaben ';
        } else if (currentHash.includes('angebot')) {
          position = 'Angebot ';
        }
    }
    document.title = `${position} ${product} ${position !== '' || product !== '' ? '-' : ''} Allianz Privatschutz`;
  }
}
